import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { DateTimeInput, FormActions, Input } from '../../../common/components/formControls';
import CentersDropdownList from '../../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onSubmit, reset, initialize, loading, t }) => {
	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('SentEmails_Center')} />
						</Col>
						<Col sm={6}>
							<Field name='adHoc' component={Input} componentClass='select' label={t('SentEmails_AdHoc')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='parentName' component={Input} type='text' label={t('SentEmails_Parent')} />
						</Col>
						<Col sm={6}>
							<Field name='toEmail' component={Input} type='text' label={t('SentEmails_ToEmail')} />
						</Col>
					</Row>
					<Row>
						<Col sm={3}>
							<Field name='periodFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} placeholder={t('Common_From')} label={t('SentEmails_Period')} />
						</Col>
						<Col sm={3}>
							<Field name='periodTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
						<Col sm={6}>
							<Field name='sender' component={Input} type='text' label={t('SentEmails_Sender')} />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'sentEmailsFilter' })(withTranslation()(Filter));